module.exports = __webpack_public_path__ + "static/media/NC.1cec7385.svg";